<template>
  <div class="body">
    <div class="loader disable" style="margin-top: 16px;" v-show="loader"></div>
    <form class="login-form" v-on:submit.prevent="submitForm()">
      <div class="header">
        <img :src="'/static/icons/supplier-icon/rj-logo.svg'" />
        <div class="title">RJ Partners</div>
        <div class="description">ระบบจัดการนัดหมายผู้ให้บริการ</div>
      </div>
      <div style="margin-top: 32px;">
        <input
          type="email"
          name="email"
          autocomplete="username"
          class="custom-input"
          :class="{ error: errors.has('email') | isAuthError }"
          :placeholder="'อีเมล'"
          v-validate="'required|email'"
          v-model="email"
        />
      </div>
      <div
        class="password-form"
        :class="{ error: errors.has('password') | isAuthError }"
      >
        <input
          :type="isShowPassword ? 'text' : 'password'"
          name="password"
          autocomplete="current-password"
          class="custom-input-password"
          :placeholder="'รหัสผ่าน'"
          v-validate="'required'"
          v-model="password"
        />
        <div class="password-visibility" @click="togglePasswordVisibility">
          <i
            class="fas"
            :class="{
              'fa-eye-slash': isShowPassword,
              'fa-eye': !isShowPassword
            }"
          ></i>
        </div>
      </div>
      <div
        class="alert-error"
        v-if="(errors.has('email') && errors.has('password')) || isAuthError"
      >
        <i class="fa fa-info-circle"></i>
        {{ "อีเมล หรือ รหัสผ่านไม่ถูกต้อง" }}
      </div>
      <div class="alert-error" v-else-if="errors.has('email')">
        <i class="fa fa-info-circle"></i>
        {{ "อีเมลไม่ถูกต้อง" }}
      </div>
      <div class="alert-error" v-else-if="errors.has('password')">
        <i class="fa fa-info-circle"></i>
        {{ "กรุณากรอกรหัสผ่าน" }}
      </div>
      <div style="margin-top: 16px;">
        <button type="submit" class="btn submit-button">
          {{ "เข้าสู่ระบบ" }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { navigationMenu, permissionRole } from "../../lib/mapper";

export default {
  data() {
    return {
      email: "",
      password: "",
      isAuthError: false,
      isShowPassword: false
    };
  },
  computed: {
    loader() {
      return this.$store.state.loader;
    }
  },
  watch: {
    email: function(newValue) {
      if (this.isAuthError === true && newValue !== "") {
        this.isAuthError = false;
      }
    },
    password: function(newValue) {
      if (this.isAuthError === true && newValue !== "") {
        this.isAuthError = false;
      }
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.isShowPassword = !this.isShowPassword;
    },
    async submitForm() {
      const result = await this.$validator.validate();

      if (result) {
        try {
          // Set Login Parameters
          const params = {
            email: this.email,
            password: this.password
          };

          // Login
          const { accessToken, refreshToken } = await this.login(params);

          // Set Authorized Token
          baanRueJaiClient.setAuthorizationToken(accessToken);

          // Set Access Token
          localStorage.setItem("supplierAccessToken", accessToken);
          localStorage.setItem("supplierRefreshToken", refreshToken);

          // Auth
          const {
            providerId,
            firstName,
            lastName,
            email,
            adminRole
          } = await this.auth();
          
          // Get Role Id
          const { roleId } = adminRole;

          // Set Information
          localStorage.setItem("supplierProviderId", providerId || "");
          localStorage.setItem("supplierFirstName", firstName);
          localStorage.setItem("supplierLastName", lastName);
          localStorage.setItem("supplierEmail", email || "");

          // Validate Ruejai Partner Admin Role
          if (roleId === permissionRole.RJPADMIN) {
            localStorage.setItem("supplierRoleId", roleId);
            localStorage.setItem("supplierProviderName", `${firstName} ${lastName}`);

            this.$router.push({
              name: "SupplierInvoiceDashboard",
              query: { status: 'in_progress' }
            });
          } else {
            // Get Provider profile
            const { name, logo_url: logoUrl } = await this.getProviderProfile(
              providerId
            );

            localStorage.setItem("supplierProviderName", name);
            localStorage.setItem("supplierProviderImage", logoUrl);

            this.$router.push({
              name: "SupplierJobList",
              params: { navigationMenu: navigationMenu.NEW }
            });
          }
        } catch (error) {
          this.isAuthError = true;

          console.error(error);
        }
      }
    },
    async login(params) {
      return await baanRueJaiClient.others.supplier.login(params);
    },
    async auth() {
      return await baanRueJaiClient.others.supplier.auth();
    },
    async getProviderProfile(id) {
      return await baanRueJaiClient.others.supplier.getProviderProfile(id);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";

.body {
  background-image: url("/static/backgrounds/bg-supplier-login-desktop.svg");
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 16px;
}

.login-form {
  background-color: $white;
  border-radius: 8px;
  padding: 16px;
  width: 312px;
  box-shadow: 8px 8px 20px 0 rgba(0, 0, 0, 0.25);
}

.header {
  text-align: left;
  margin-top: 32px;
}

.title {
  color: $black;
  font-weight: bold;
  font-size: $font-40;
  margin-top: -4px;
}

.description {
  color: $light-gray-2;
  font-size: $font-16;
}
.custom-input {
  background-color: $white;
  border-radius: 4px;
  border: 1px solid $color-light-gray-1;
  box-sizing: border-box;
  color: $black;
  display: inline-block;
  font-size: $font-16;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}

.password-form {
  display: flex;
  flex-direction: row;
  background-color: $white;
  border-radius: 4px;
  border: 1px solid $color-light-gray-1;
  box-sizing: border-box;
  height: 40px;
  line-height: 40px;
  outline: none;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  margin-top: 16px;
}

.password-form:hover,
.password-form:focus,
.custom-input:hover,
.custom-input:focus {
  border: solid 1px $light-gray-2;
}

.password-form.error,
.custom-input.error {
  border: solid 1px $error;
}

.custom-input-password {
  width: 85%;
  border: none;
  font-size: $font-16;
  color: $black;
  padding: 0 15px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.password-visibility {
  background-color: $white;
  border: none;
  width: 15%;
  padding: 0px;
  color: $light-gray-2;
  text-align: center;
}

.submit-button {
  width: 100%;
  height: 44px;
  color: $white;
  background: $supplier-primary-color;
  font-weight: bold;
  font-size: $font-16;
  border-radius: 8px;
  border: none;

  &:hover:not(:disabled) {
    background: $supplier-primary-light-color;
  }
}
.alert-error {
  margin-top: 4px;
  color: $error;
  text-align: right;
  font-size: $font-12;
}

@media screen and (max-width: $sm-size) {
  .body {
    background-image: url("/static/backgrounds/bg-supplier-login-mobile.svg");
  }
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px $white inset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/pages/Login.vue